import React from "react";
import { graphql, Link } from "gatsby";
import Img from "gatsby-image";
import Layout from "../components/layout";

export default function Galleries ({data}) {

    const galleries = data.allFile.distinct.map((path, index) => {
        const galleryName = path.split('/')[1];
        const slug = galleryName.toLowerCase().split(' ').join('-');
        const thumbnail = data.allFile.nodes.find(node => node.relativeDirectory === path).childImageSharp.fluid;

        return (
            <Link to={'/gallery/' + slug} className="image-gallery-listing" key={index}>
                <h2>{galleryName}</h2>
                <Img fluid={thumbnail} />
                <span>View gallery</span>
            </Link>
        );
    });

    return (
        <Layout>
            <div className="image-galleries-page">
                <h1>Galleries</h1>
                <div className="image-galleries">
                    {galleries}
                </div>
            </div>
        </Layout>
    )
}

export const pageQuery = graphql`
    query {
        allFile(filter: {relativeDirectory: {glob: "galleries/*"}}) {
            nodes {
                relativeDirectory
                childImageSharp {
                    fluid {
                        ...GatsbyImageSharpFluid
                    }
                }
            }
            distinct(field: relativeDirectory)
        }
    }
`;